import { graphql } from 'react-relay';
export const ContentOwnershipCheckRestrictionsQuery = graphql`
	query ContentOwnershipCheckRestrictionsQuery($accountId: String!, $contentId: ID!) {
		userWithContentRestrictions(accountId: $accountId, contentId: $contentId) {
			accountId
			hasSpaceEditPermission
			hasSpaceViewPermission
			restrictingContent {
				id
				links {
					webui
					base
				}
			}
			operations {
				operation
			}
		}
	}
`;
